import {
    FilterLogic,
    type DiscoverySearchResponse,
} from "@amzn/ads-discovery-theme-service-typescript-client";
import type { AsyncState, UseAsyncActions } from "@react-hookz/web";
import { useAsync } from "@react-hookz/web";

import type { SearchSortAttribute } from "../../api/adsApi/adsApi.interfaces";
import { getDiscoveryApiClient } from "../../api/discoveryApi/discoveryApi";
import { DEFAULT_MARKETING_NARRATIVE_SEARCH_QUERY } from "../../config/filters.config";
import { ContentStatus } from "../../types/content";
import { useAsyncErrorStatusNotification } from "../notifications/useAsyncErrorStatusNotification";

const MAX_MARKETING_NARRATIVES_PER_QUERY = 120;

export function useSearchMarketingNarrativesAction(): [
    AsyncState<DiscoverySearchResponse>,
    UseAsyncActions<
        DiscoverySearchResponse,
        [string[], string, string | undefined, SearchSortAttribute]
    >,
] {
    const [marketingNarrativesState, marketingNarrativesAction] = useAsync(
        async (
            filters: string[],
            searchQuery: string,
            nextPageToken: string | undefined,
            sortAttribute: SearchSortAttribute,
        ) => {
            const response = await (
                await getDiscoveryApiClient()
            ).searchContents({
                contentStatus: ContentStatus.ACTIVE,
                filters,
                maxResults: MAX_MARKETING_NARRATIVES_PER_QUERY,
                nextPageToken,
                query:
                    searchQuery.trim() === ""
                        ? DEFAULT_MARKETING_NARRATIVE_SEARCH_QUERY
                        : searchQuery.trim(),
                sortAttribute,
                categoryFilterLogic: FilterLogic.SAME_TOP_PARENT_OR,
            });
            return response ?? [];
        },
        { contents: [], nextPageToken: "", numHits: 0 },
    );

    useAsyncErrorStatusNotification(marketingNarrativesState, [
        "UnauthorizedException",
    ]);

    return [marketingNarrativesState, marketingNarrativesAction];
}
